import { render, staticRenderFns } from "./wxsfirmware.vue?vue&type=template&id=9b7457f0&"
import script from "./wxsfirmware.vue?vue&type=script&lang=js&"
export * from "./wxsfirmware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports